module.exports = __webpack_public_path__ + "static/media/mountains.04488dcb.svg";